// extracted by mini-css-extract-plugin
export default {"value":"PricingCompetitiveness_value__GWQCv","header":"PricingCompetitiveness_header__0MSnD","row":"PricingCompetitiveness_row__ipsvY"};